import { systemConfig } from "@/config/systemConfig";
import { Inspection } from "@/types/Inspection.type";
import { Template } from "@/types/Template.type";
import { getTemplate } from "@/utils/inspection.utils";
import React from "react";

export const useTemplate = (inspection: Inspection | undefined) => {
    const [inspectionStructure, setInspectionStructure] = React.useState<Template>();
    let templateId = inspection?.template?.template;
    const version = inspection?.template?.version;
    if (inspection?.inspectionLevel?.name === 'Positive Release') // Dirty fix: Interim solution, will be replace by robust solution later on 
    {
        templateId = `${systemConfig.tenantId}_positive-release`;
    }

    React.useEffect(() => {
        function loadInspectionStructure() {
            if (templateId) {
                const structure = getTemplate(templateId, version);

                setInspectionStructure(structure);
            }
        }
        loadInspectionStructure();
    }, [templateId, version]);

    return inspectionStructure;
};